/** Treatments which get the form 'dentist/treatment/some-treatment' instead of just
 * 'treatment/some-treatment' */
export const SPECIAL_CASED_DENTAL_TREATMENTS = [
  'Veneers',
  'Teeth Whitening',
  'Crown And Bridge',
  'Dental Implants',
];

/** Topics which are misspelled in known inbound links. We remap them here so the next
 * segment can treat them normally.
 */
export const FIXED_TOPIC_SPELLINGS = new Map([
  ['Admin', 'Medical Administrator'],
  ['Allergist', 'Allergy'],
  ['Bariatric Obesity Surgeon', 'Bariatric (obesity) Surgeon'],
  ['Bio Balance', 'Bio-balance'],
  ['Bulk Billing', 'Bulk Billing GP'],
  ['Clinical Pharmacology', 'Clinical Pharmacologist'],
  ['Covid 19 Vaccinations', 'Covid-19 Vaccinations'],
  ['Covid 19 Testing', 'Covid-19 Testing'],
  ['Community Child Health', 'Paediatrician'],
  ['Ct Scan', 'Ct Scan (computerised Tomography)'],
  ['Dental Practice', 'Dentist'],
  ['Dental Therapy', 'Dental Therapist'],
  ['Dento Maxillofacial Radiologist', 'Dento-maxillofacial Radiologist'],
  ['Dento Maxillofacial Radiology', 'Dento-maxillofacial Radiologist'],
  ['Diabetes Education', 'Diabetes Educator'],
  ['Doctor', 'GP'],
  ['ENT Specialist', 'Otorhinolaryngologist'],
  ['Flexible Inserts/orthotics', 'Podiatrist'],
  ['General Practice', 'GP'],
  ['Lactation Consultation', 'Lactation Consultant'],
  ['Medical Centre', 'GP'],
  ['Medical Practice', 'GP'],
  ['Midwifery', 'Midwife'],
  ['Mirena Insertion And Removal', 'Mirena Insertion & Removal'],
  ['Neuropsychologist', 'Clinical Neuropsychologist'],
  [
    'Nutritional And Environmental Medicine Physician',
    'Nutritional & Environmental Medicine Physician',
  ],
  [
    'Obstetric And Gynaecological Ultrasound Physician',
    'Obstetric & Gynaecological Ultrasound Physician',
  ],
  ['Obstetrician Gynaecologist', 'Gynaecologist'],
  ['Oral And Maxillofacial Surgeon', 'Maxillofacial Surgeon'],
  ['Orthotists', 'Prosthetist'],
  ['Paediatric Dentistry', 'Paediatric (children) Dentistry'],
  ['Periodontics', 'Periodontist'],
  ['Phelbologist', 'Phlebology'],
  ['Phelbology', 'Phlebology'],
  ['Plastic And Reconstructive Surgeon', 'Plastic & Reconstructive Surgeon'],
  ['Radiation Oncology', 'Radiation Oncologist'],
  ['Respiratory And Sleep Medicine', 'Respiratory & Sleep Physician'],
  ['Respiratory And Sleep Physician', 'Respiratory & Sleep Physician'],
  ['Skinchecks', 'Skin Checks'],
  ['Sports And Exercise Medicine', 'Sports Medicine'],
  ['Trichology', 'Trichologist'],
  ['Urogynaecology', 'Urogynaecologist'],
  ['Womens Health Specialist', "Women's Health Specialist"],
  ['Womens Health', "Women's Health"],
  ['X Ray Radiographs', 'X-ray (radiographs)'],
  ['X Ray', 'X-ray (radiographs)'],
  ['Xray', 'X-ray (radiographs)'],
]);

/** Treatments for which known inbound links exist, but are missing the 'treatment' separator. */
export const BARE_TREATMENTS = new Set([
  'Acupuncture',
  'Addiction Medicine',
  'Allergy',
  'Anaesthetics',
  'Angiogram',
  'Art Therapy',
  'Bio-balance',
  'Bio Balance',
  'Breast Surgery',
  'Cardiology',
  'Clinical Neuropsychology',
  'Ct Scan (computerised Tomography)',
  'Dento Maxillofacial Radiology',
  'Dermal Therapy',
  'Dermatology',
  'Endocrinology',
  'Exercise Physiology',
  'Flexible Inserts/orthotics',
  'Fractured Hip',
  'Gastroenterology',
  'Gynaecology',
  'Haematology',
  'Hand Surgery',
  'Immunology',
  'Massage Therapy',
  'Massage',
  'Methadone Treatment Program',
  'Mirena Insertion & Removal',
  'Mri',
  'Naturopathy',
  'Nephrology',
  'Neurosurgery',
  'Obstetric Medicine',
  'Orthodontics',
  'Osteopathy',
  'Otorhinolaryngology',
  'Paediatric (children) Dentistry',
  'Paediatric Allergy',
  'Paediatric Cardiology',
  'Paediatric Endocrinology',
  'Paediatric Neurology',
  'Paediatric Physiotherapy',
  'Pain Medicine',
  'Pathology',
  'Pharmacy',
  'Phlebology',
  'Pilates',
  'Podiatry',
  'Psychology',
  'Psychotherapy',
  'Radiology',
  'Reflexology',
  'Reiki',
  'Respiratory Medicine',
  'Rheumatology',
  'Sexual Health',
  'Skin Cancer',
  'Skin Checks',
  'Sports Medicine',
  'Tropical Medicine',
  'Ultrasound',
  'X-ray (radiographs)',
  "Women's Health",
]);
